import { LocalStorageService } from "../common";


const cacheUtils = {
    /**
     * Checks the version in meta.json against the version stored in local storage at most every 5 minutes
     * @param expirationMilliseconds how many milliseconds to wait before checking again (default = 300000 or 5 minutes)
     */
    checkVersion: async (currentVersion: string, versionFileUrl: string, expirationMilliseconds: number = 300000) => {
      const isProduction = process.env.NODE_ENV === 'production';
      // console.log('checkVersion', { currentVersion, metaFileUrl, isProduction });
      if (isProduction) {
        const now = new Date().getTime();
        const lastVersionCheck = LocalStorageService.getItem('LAST_VERSION_CHECK');
        const oldAppVersion = LocalStorageService.getItem('APP_VERSION');
        const nextCheckTime = lastVersionCheck ? +lastVersionCheck + expirationMilliseconds : 0;
        // console.log('checkVersion nextCheckTime', { nextCheckTime, now });
        if (nextCheckTime <= now) {
          // const response = await baseAxios.get(versionFileUrl + `?t=${now}`);
          // // console.log('checkVersion meta', { meta });
          LocalStorageService.setItem('LAST_VERSION_CHECK', now);
          // if (oldAppVersion !== currentVersion) {
          //   // console.log('doing hard refresh');
          //   // cacheUtils.clearLocalStorage();
          //   // cacheUtils.clearSessionStorage();
          //   cacheUtils.doHardRefresh();
          //   LocalStorageService.setItem('LAST_VERSION_CHECK', currentVersion);
          // }
        }
      }
    },
  
    clearSessionStorage() {
      // console.log('clearSessionStorage', window.location, { caches });
      sessionStorage.clear();
    },
  
    clearLocalStorage() {
      // console.log('clearLocalStorage', window.location, { caches });
      const x = LocalStorageService.getItem('defaultLoginOu');
      const y = localStorage.getItem('app-theme');
      const z = LocalStorageService.getItem('LAST_VERSION_CHECK');
      const accessToken = LocalStorageService.getItem('ACCESS_TOKEN');
      const accessTokenLastExpire = LocalStorageService.getItem('ACCESS_TOKEN_EXPIRE');
  
      localStorage.clear();
      if (x) LocalStorageService.setItem('defaultLoginOu', x);
      if (y) localStorage.setItem('app-theme', y);
      if (z) LocalStorageService.setItem('LAST_VERSION_CHECK', z);
      if (accessToken) LocalStorageService.setItem('ACCESS_TOKEN', accessToken);
      if (accessTokenLastExpire) LocalStorageService.setItem('ACCESS_TOKEN', accessTokenLastExpire);
    },
  
    // clearCookies() {
    //   // console.log('clearCookies', window.location, { caches });
    //   if (cookies) {
    //     const allCookies = cookies.getAll();
    //     if (allCookies) {
    //       allCookies.map((c) => cookies.remove(c));
    //     }
    //   }
    // },
  
    doHardRefresh(clearLocalStorage = false, clearSessionStorage = false) {
      // console.log('doHardRefresh', window.location, { caches });
  
      caches.keys().then((keyList) =>
        Promise.all(
          keyList.map((key) => {
            return caches.delete(key);
          })
        )
      );
  
      // Give some time for the caches to actually clear
      setTimeout(() => {
        window.location.reload();
      }, 1300);
    },
  };
  
  export { cacheUtils };
  